var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "app-main-content financial-report" }, [
    _c(
      "div",
      { staticClass: "details-view" },
      [
        _c("div", { staticClass: "main-content" }, [
          _c(
            "span",
            {
              staticStyle: {
                position: "absolute",
                right: "10px",
                "margin-top": "5px",
                "z-index": "9999"
              }
            },
            [
              _c(
                "el-link",
                {
                  attrs: { type: _vm.lbAccountType, no: "lbAccount" },
                  on: { click: _vm.selectAccountSetHandler }
                },
                [_vm._v(_vm._s(_vm.lbAccount))]
              )
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "tabs-container" },
            [
              _c(
                "el-tabs",
                {
                  staticStyle: { width: "100%" },
                  attrs: { type: "card" },
                  on: { "tab-click": _vm.handleTabClick },
                  model: {
                    value: _vm.activeTabName,
                    callback: function($$v) {
                      _vm.activeTabName = $$v
                    },
                    expression: "activeTabName"
                  }
                },
                [
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BalanceSheet"),
                        name: "balanceSheet"
                      }
                    },
                    [
                      _c("balance-sheet-statement", {
                        key: "balanceSheet",
                        ref: "balanceSheet",
                        attrs: { "account-set": _vm.accountSet }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ProfitLoss"),
                        name: "profitLoss"
                      }
                    },
                    [
                      _c("income-statement-view", {
                        key: "profitLoss",
                        ref: "profitLoss",
                        attrs: { "account-set": _vm.accountSet }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BalanceSheetQuarter"),
                        name: "balanceSheetQuarter"
                      }
                    },
                    [
                      _c("balance-sheet-statement", {
                        key: "balanceSheetQuarter",
                        ref: "balanceSheetQuarter",
                        attrs: {
                          "report-type": "quarter",
                          "account-set": _vm.accountSet
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ProfitLossQuarter"),
                        name: "profitLossQuarter"
                      }
                    },
                    [
                      _c("income-statement-view", {
                        key: "profitLossQuarter",
                        ref: "profitLossQuarter",
                        attrs: {
                          "report-type": "quarter",
                          "account-set": _vm.accountSet
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_BalanceSheetYear"),
                        name: "balanceSheetYear"
                      }
                    },
                    [
                      _c("balance-sheet-statement", {
                        key: "balanceSheetYear",
                        ref: "balanceSheetYear",
                        attrs: {
                          "report-type": "year",
                          "account-set": _vm.accountSet
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-tab-pane",
                    {
                      attrs: {
                        label: _vm.$t("CargoMsg.Cargo_ProfitLossYear"),
                        name: "profitLossYear"
                      }
                    },
                    [
                      _c("income-statement-view", {
                        key: "profitLossYear",
                        ref: "profitLossYear",
                        attrs: {
                          "report-type": "year",
                          "account-set": _vm.accountSet
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          )
        ]),
        _c("account-set-popup", {
          ref: "refAccountSetPopup",
          attrs: {
            mode: _vm.accountSetPopup.mode,
            visible: _vm.accountSetPopup.visible,
            "load-accounting-document-type-flag": false,
            "load-mapping-departments-flag": false,
            "load-mapping-staffs-flag": false,
            "load-accounting-documents-rule-flag": false,
            "sort-fiscal-period-desc": true,
            "load-year-quarter": true
          },
          on: {
            "update:visible": function($event) {
              return _vm.$set(_vm.accountSetPopup, "visible", $event)
            },
            cancel: function() {
              return (_vm.accountSetPopup.visible = false)
            },
            select: _vm.accountSetSelectHandler
          }
        })
      ],
      1
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }